<script setup>
import {computed} from 'vue'

const props = defineProps({
    contentAreaName: String
})

import {usePageEditorStore} from '/src/stores/pageEditor'
import {useRouter} from "vue-router"

const router = useRouter()
const pageEditorStore = usePageEditorStore()
const activeContentAreaName = computed(() => pageEditorStore.activeContentAreaName)
const hoverContentAreaName = computed(() => pageEditorStore.hoverContentAreaName)

const area = computed(() => pageEditorStore.contentAreas.find(o => o.name === props.contentAreaName))
const isSectionArea = computed(() => !!area.value?.sectionId)

const classNames = computed(() => {
    let names = isSectionArea.value ? 'ps-2' : ''

    if (props.contentAreaName === activeContentAreaName.value) {
        names += ' active'
    } else if (props.contentAreaName === hoverContentAreaName.value) {
        names += ' list-group-item-hover'
    } else {
        names += ' text-body-secondary'
        names += isSectionArea.value ? ' bg-body-tertiary' : ' bg-body-secondary'
    }

    return names
})

const onMouseover = () => {
    pageEditorStore.hoverContentAreaName = props.contentAreaName
}

const onMouseout = () => {
    pageEditorStore.hoverContentAreaName = ''
}

const onClick = async () => {
    await pageEditorStore.goToContentArea({
        router,
        contentAreaName: props.contentAreaName
    })

    pageEditorStore.scrollToContentArea({
        contentAreaName: props.contentAreaName
    })
}
</script>

<template>
    <a v-if="area" role="button" class="list-group-item list-group-item-action py-1 ps-0 strong text-uppercase small"
       :class="classNames" @mouseover="onMouseover" @mouseout="onMouseout" @click="onClick">
        <small class="ps-3 flex-fill">{{ area.label }}</small>
    </a>
</template>

<style scoped>
.list-group-item {
    border-color: transparent !important;
    font-size: 0.75rem;
    font-weight: 500;
}

.list-group-item-hover {
    z-index: 1;
    color: var(--bs-list-group-action-hover-color);
    text-decoration: none;
    background-color: rgba(9, 110, 253, 0.2) !important;
}
</style>